import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardHeader,
  FileInput,
  FileInputExtendedProps,
  Form,
  FormField,
  Select,
  TextInput,
} from "grommet";
import { useNavigate } from "react-router-dom";
import "./CreateUser.css";
import { UserType } from "../types/UserType";
import usersService from "../users.service";
import { useErrorHandler } from "../../../../common/context/ErrorStore";
import { AxiosError } from "axios";
import createuserService from "./createuser.service";
import { UserFromFileType } from "../types/UserFromFileType";
import { OrganizationType } from "../types/OrganizationType";
import StandardColors from "../../../../../../../util/StandardColors";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../../Hooks/useStore";
import { Mixpanel } from "../../../../../../../util/Helper";
import createFlightService from "../CreateFlight/create-flight.service";

const CUSTOM_TYPE_OPTIONS = [
  {
    label: "Crew",
    value: "crew",
  },
  {
    label: "EMS",
    value: "ems",
  },
  {
    label: "Captain",
    value: "captain",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Super Admin ",
    value: "superAdmin",
  },
  {
    label: "Coordinator",
    value: "coordinator",
  },
  {
    label: "Dispatch",
    value: "dispatch",
  },
];

const CUSTOM_TYPE_OPTIONS_SECOND = [
  {
    label: "Crew",
    value: "crew",
  },
  {
    label: "EMS",
    value: "ems",
  },
  {
    label: "Captain",
    value: "captain",
  },
  {
    label: "Admin",
    value: "admin",
  },
  {
    label: "Coordinator",
    value: "coordinator",
  },
  {
    label: "Dispatch",
    value: "dispatch",
  },
];

const GENDER_OPTIONS = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
  {
    label: "Others",
    value: "others",
  },
];

function CreateUsers() {

  const { rootStore } = useStore();

  const [user, setUser] = useState({
    "custom:type": "crew",
    gender: "female"
  } as UserType);

  const [selectedOrganization, setSelectedOrganization] = useState("");

  const [organizations, setOrganizations] = useState<OrganizationType[]>([]);

  const [showBatchAddButton, setShowBatchAddButton] = useState(false);

  const [usersFromFile, setUserFromFile] = useState([] as UserFromFileType[]);

  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      rootStore.loadingStore.setShowLoader(true);
      const organizationsResponse = await usersService.listOrganizations();
      rootStore.adminStore.handleOrgList(organizationsResponse);
      rootStore.loadingStore.setShowLoader(false);
    })().catch((e) => rootStore.loadingStore.setShowLoader(false));
  }, []);

  const batchAddUsers = useCallback(async () => {
    let uInfos = localStorage.getItem("userinfo");
    if(uInfos)
      {
    const userinformation = JSON.parse(uInfos);
    Mixpanel.track("web_add_user_batch_click",{name:userinformation.username});
      }
    try {
      await usersService.batchUserCreation(rootStore.adminStore.getUserFormFile);
      rootStore.notificationToastStore.showNotification("Added users!",false, 3000);
    } catch (e) {
      console.log("error occured adding batch", e);
      if (e instanceof AxiosError) {
        rootStore.errorHandlingStore.displayError(e.message);
      } else {
        rootStore.errorHandlingStore.displayError("Error occured while adding users!");
      }
    }
  }, [rootStore.adminStore.getUserFormFile]);

  const onFormSubmit = ({ value }: { value: any }) => {
    let uInfos = localStorage.getItem("userinfo");
          if(uInfos)
            {
          const userinformation = JSON.parse(uInfos);
    Mixpanel.track("web_add_user_submit_click",{name:userinformation.username});
            }
    const {
      username,
      email,
      profile,
      gender,
      family_name,
      name,
      phoneNumber
    } = value;

    if (
      user?.["custom:type"] == "coordinator" &&
      !/^\+1\d{10}$/.test(phoneNumber)
    ) {
      alert(
        "Invalid phone number format. Please enter a phone number in the format +1xxxxxxxxxx"
      );
      return;
    }

    if (rootStore.adminStore.getSelectedOrgId === "") {
      rootStore.errorHandlingStore.displayError(
        "Invalid organization, Please select organization from the dropdown."
      );
    }
    const response = usersService.createUser({
      username,
      email,
      gender,
      familyName: family_name,
      name,
      customType: profile,
      organizationId: Number.parseInt(rootStore.adminStore.getSelectedOrgId),
      phoneNumber
    });
    response
      .then(() => {
        rootStore.notificationToastStore.showNotification("Added user!",false, 3000);
      })
      .catch((error) => {
        console.log(error);
        if (error instanceof AxiosError) {
          rootStore.errorHandlingStore.displayError(error.message);
        } else {
          rootStore.errorHandlingStore.displayError(
            "Error occured while adding user. Please reload the page!"
          );
        }
      });
  };

  useEffect(() => {
    (async () => {
      let userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        if (JSON.parse(userInfo).roleLabel.toLowerCase() == "admin") {
          let username = JSON.parse(userInfo).username;
          let userOrg = await createFlightService.getOrgByUserName(username);
          rootStore.adminStore.handleSelectedOrgId(userOrg.id)
        }
      }
    })();
  },[]);

  return (
    <Box className="create-user-container">
      <p className="message-text">Add Users</p>
      <Card pad="medium" gap="medium">
        <FileInput
          title="Upload an excel file for adding a batch."
          messages={{
            dropPrompt: "Upload an excel file containing list of users.",
          }}
          onChange={(event) => {
            let fileList = null;
            if (event != undefined) fileList = event.target.files;

            if (fileList != null) {
              for (let i = 0; i < fileList.length; i += 1) {
                const file = fileList[i];
                createuserService
                  .readFile(file)
                  .then((data: UserFromFileType[]) => {
                    rootStore.adminStore.handleShowBatchButton(true);
                    rootStore.adminStore.handleFormFile(data);
                  });
              }
            }
          }}
        />
        {rootStore.adminStore.getShowBatchButton ? (
          <Box direction="row" gap="medium" pad={"medium"} justify="end">
            <Button
              type="button"
              primary
              label="Batch Add"
              color={"brand-1"}
              onClick={batchAddUsers}
            />
          </Box>
        ) : (
          <></>
        )}
      </Card>
      <p className="message-text">Or</p>
      <Card pad="medium" gap="medium">
        <Form
          validate="change"
          onSubmit={onFormSubmit}
          className="create-user-form"
        >
          <FormField name="username" htmlFor="textinput-id" required>
            <TextInput
              placeholder="Username"
              id="textinput-id"
              name="username"
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    username: event.target.value,
                  };
                });
              }}
            />
          </FormField>
          {/* <FormField name="password" htmlFor="textinput-id" required>
            <TextInput
              placeholder="Password"
              id="textinput-id"
              name="password"
              type="password"
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    password: event.target.value,
                  };
                });
              }}
            />
          </FormField>
          <FormField name="confirm" htmlFor="textinput-id" required>
            <TextInput
              placeholder="Confirm Password"
              id="textinput-id"
              name="confirm"
              type="password"
              style={
                user.password !== user.confirm
                  ? { color: StandardColors.secondary_red_100 }
                  : {}
              }
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    confirm: event.target.value,
                  };
                });
              }}
            />
          </FormField> */}
          <FormField
            name="email"
            htmlFor="textinput-id"
            required
            validate={[
              {
                regexp:
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              },
            ]}
          >
            <TextInput
              id="textinput-id"
              name="email"
              type={"email"}
              placeholder="Email"
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    email: event.target.value,
                  };
                });
              }}
            />
          </FormField>
          <FormField name="name" htmlFor="textinput-id" required>
            <TextInput
              id="textinput-id"
              name="name"
              placeholder="First Name"
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    name: event.target.value,
                  };
                });
              }}
            />
          </FormField>
          <FormField name="family_name" htmlFor="textinput-id" required>
            <TextInput
              id="textinput-id"
              name="family_name"
              placeholder="Last Name"
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    family_name: event.target.value,
                  };
                });
              }}
            />
          </FormField>
          <FormField
            label="Gender"
            name="gender"
            htmlFor="textinput-id"
            required
          >
            <Select
              name="gender"
              labelKey={"label"}
              valueKey={{ key: "value", reduce: true }}
              options={GENDER_OPTIONS}
              defaultValue={"female"}
              value={user.gender}
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    gender: event.option.value,
                  };
                });
              }}
            />
          </FormField>

          <FormField
            label="Profile"
            name="profile"
            htmlFor="textinput-id"
            required
          >
            <Select
              name="profile"
              labelKey={"label"}
              valueKey={{ key: "value", reduce: true }}
              options={rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? CUSTOM_TYPE_OPTIONS_SECOND : CUSTOM_TYPE_OPTIONS}
              value={user["custom:type"]}
              defaultValue={"crew"}
              onChange={(event) => {
                setUser((prev) => {
                  return {
                    ...prev,
                    "custom:type": event.option.value,
                  };
                });
              }}
            />
          </FormField>

          {user?.["custom:type"] === "coordinator" && (
            <FormField name="phoneNumber" htmlFor="textinput-id" required>
              <TextInput
                id="textinput-id"
                name="phoneNumber"
                placeholder="Phone number"
              />
            </FormField>
          )}

          {rootStore.adminStore.getOrgList.length > 0 ? (
            <div className={rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? "create-user-org-outer" : ""}>
            <FormField
              label="Organization"
              name="organization"
              htmlFor="textinput-id"
              required
            >
              <Select
                name="organization"
                labelKey={"label"}
                valueKey={{ key: "value", reduce: true }}
                options={rootStore.adminStore.getOrgList.map((org) => {
                  return {
                    label: org.name,
                    value: org.id,
                  };
                })}
                value={rootStore.adminStore.getSelectedOrgId}
                defaultValue={""}
                onChange={(event) => {
                  rootStore.adminStore.handleSelectedOrgId(event.option.value);
                }}
              />
            </FormField>
            </div>
          ) : (
            <></>
          )}

          <Box direction="row" gap="medium" pad={"medium"} justify="end">
            <Button
              type="button"
              label="Back"
              color={"brand-1"}
              onClick={() => {
                let uInfos = localStorage.getItem("userinfo");
          if(uInfos)
            {
          const userinformation = JSON.parse(uInfos);
                Mixpanel.track("web_add_user_back_click",{name:userinformation.username});
            }
                navigate(-1);
              }}
            />
            <Button type="reset" onClick={() => {
               let uInfos = localStorage.getItem("userinfo");
               if(uInfos)
                 {
               const userinformation = JSON.parse(uInfos);
              
              Mixpanel.track("web_add_user_reset_click",{name:userinformation.username});
              } }} label="Reset" color={"brand-1"} />
            <Button type="submit" primary label="Add" color={"brand-1"} />
          </Box>
        </Form>
      </Card>
    </Box>
  );
}

export default observer(CreateUsers);
